<template>
  <header :style="headerStyle" :class="`${headerClass} ${hidden ? 'header--hidden' : ''} ${dark ? 'header--dark' : ''}`">
    <h1 class="header__title link"><router-link :to="{ name: 'FrontPage', params: {} }">desperate<span class="header__title__dot">.</span></router-link></h1>
    <div class="header__nav-trigger" v-on:click="trigger">
      <span class="header__nav-trigger__text">we hide secrets here</span>
      <span class="header__nav-trigger__burger link">
          <span class="header__nav-trigger__burger__dot"></span>
          <span class="header__nav-trigger__burger__dot"></span>
          <span class="header__nav-trigger__burger__dot"></span>
          <span class="header__nav-trigger__burger__dot"></span>
      </span>
    </div>
  </header>
</template>

<script>
import Menu from '@/components/Menu/Menu';
import './style.scss';

export default {
  name: 'Header',
  data() {
    return {
      headerClass: 'header',
      headerStyle: {top: '0px'},
    };
  },
  mounted() {

  },
  methods: {
  },
  props: {
    trigger: Function,
    dark: Boolean,
    hidden: Boolean,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Header/Header.vue